import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/translation/publish/translation.changes.query.gql"
import type {
  CatalogChangesQuery,
  CatalogChangesQueryVariables,
} from "@/v2-backoffice-client/translation/publish/__types__/translation.changes.query"

type Options = QueryHookOptions<
  CatalogChangesQuery,
  CatalogChangesQueryVariables
>

export function useCatalogChangesQuery(options?: Options) {
  return useQuery<CatalogChangesQuery, CatalogChangesQueryVariables>(
    query,
    options,
  )
}
